@if (!isLogged()) {
  <div>
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
}

@if (isLogged()) {
  <div>
    @if (isLogged()) {
      <app-top-navbar></app-top-navbar>
    }
    <div class="global-content">
      <app-left-navbar></app-left-navbar>
      <div class="main-content p-2 p-lg-4">
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </div>
    </div>
  </div>
}

<ng-template #template>
  <router-outlet></router-outlet>
</ng-template>

<app-loader></app-loader>
<app-snackbar></app-snackbar>
<app-dialog-modal></app-dialog-modal>
